// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"353":"7433403a","453":"3df92c28"}[chunkId] + ".chunk.js";
};